import { render, staticRenderFns } from "./ScreeningCustomer.vue?vue&type=template&id=140cbca8&scoped=true&"
import script from "./ScreeningCustomer.vue?vue&type=script&lang=js&"
export * from "./ScreeningCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningCustomer.vue?vue&type=style&index=0&id=140cbca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140cbca8",
  null
  
)

export default component.exports